import { Button } from "@mui/material";
import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_START_INLINE_GAP,
  IStyledAttributes,
} from "@ryde/shared";
import { blueGreyMui, greyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const DrawerHeaderStyled = styled.header.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drawer-header",
})`
  width: 100%;
  background-color: rgb(255, 255, 255);
  border-bottom: 1px solid rgb(224, 224, 224);
  display: flex;
  align-items: center;
  padding-inline-start: ${DRAWER_START_INLINE_GAP}px;
  min-height: 56px;
  padding-block: 8px;
  transition:
    filter 0.55s ease-out,
    backdrop-filter 0.55s ease-out;
  &.inner-item-editing {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
    pointer-events: none;
  }

  .DrawerCloseIconButton {
    margin-inline-start: -8px;
    margin-inline-end: 8px;
  }

  .DrawerHeader-History {
    margin-inline-start: auto;
    margin-inline-end: 6px;
  }

  .sub_header {
    color: ${greyMui._800};
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .DrawerHeaderTitle {
      order: 1;
    }
    .DrawerCloseIconButton {
      order: 2;
      margin-inline-start: auto;
      margin-inline-end: 6px;

      > svg {
        height: 20px;
        width: 20px;
      }
    }
  }
`;

export const DrawerHeaderButton = styled(Button).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "drawer-header-button",
})`
  color: ${blueGreyMui._500};
  font-weight: normal;
  text-transform: none;

  &:hover {
    background-color: ${blueGreyMui._50};
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    font-size: 12px;
    line-height: 14px;
  }
`;
